import React from 'react';
import { useStyletron } from 'baseui';
import { Comment } from '@letsdothis/lds/lib/experimental/Icon';

import Button from '../Button';

export interface HighFiveProps {
  disabled?: boolean;
  text?: string;
  onClick?: () => void;
  title?: string;
  active?: boolean;
}

const HighFive: React.FC<HighFiveProps> = (props: HighFiveProps) => {
  const [css] = useStyletron();
  const { disabled, text = 'Reply', onClick, title = 'Reply', active } = props;

  return (
    <div className={css({ display: 'flex', alignItems: 'center' })}>
      <Button
        disabled={disabled}
        Icon={Comment}
        text={text}
        onClick={onClick}
        title={title}
        active={active}
      />
    </div>
  );
};

export default HighFive;
